module.exports = __webpack_public_path__ + "static/img/icon-delete.f1797ab1.svg";